const projects = [
  {
    img: require("../assets/govuk-crest.png"),
    title: "DART | MHRA",
    description:
      "Clinical Practice Research Datalink (CPRD) is a real-world research service supporting retrospective and prospective public health and clinical studies. CPRD research data services are delivered by the Medicines and Healthcare products Regulatory Agency with support from the National Institute for Health and Care Research (NIHR), as part of the Department of Health and Social Care.",
    urls: ["https://www.cprd.com"],
  },
  {
    img: require("../assets/govuk-crest.png"),
    title: "IRSP | MHRA",
    description:
      "Clinical Practice Research Datalink (CPRD) is a real-world research service supporting retrospective and prospective public health and clinical studies. CPRD research data services are delivered by the Medicines and Healthcare products Regulatory Agency with support from the National Institute for Health and Care Research (NIHR), as part of the Department of Health and Social Care.",
    urls: ["https://www.cprd.com"],
  },
  {
    img: require("../assets/hdr-logo.png"),
    title: "HDR | Andrew Reid",
    description:
      "HDR | Andrew Reid needed a project management system to support its rapid international growth while maintaining high standards and consistency. The system had to be easy to use, support offline mobile use, and offer different project views. The system now manages equipment details, certifications, safety risk assessments, and all aspects of their projects worldwide.",
    urls: ["https://www.hdrinc.com"],
  },
  {
    img: require("../assets/waterscan-logo.png"),
    title: "Waterscan",
    description:
      "Waterscan is a pioneering company based in the United Kingdom, specializing in water management and sustainability solutions. With a steadfast commitment to environmental stewardship and resource efficiency, Waterscan has established itself as a leader in the field, offering innovative strategies to optimize water usage across various industries.",
    urls: ["https://waterscan.com/"],
  },
  {
    img: require("../assets/nhs-logo.png"),
    title: "BSPS | NHS",
    description:
      "BSPS is one of the largest pathology networks in the country, providing safe, high quality, clinically-led diagnostics. The pathology network is a partnership between NHS Trusts, including Frimley Health NHS Foundation Trust, Royal Surrey NHS Foundation Trust, Ashford & St Peter’s Hospitals NHS Foundation Trust, Royal Berkshire NHS Foundation Trust, and Surrey and Sussex Healthcare NHS Trust.",
    urls: ["https://www.berkshireandsurreypathologyservices.nhs.uk"],
  },
  {
    img: require("../assets/numerous-logo.png"),
    title: "Numerous",
    description:
      "Numerous is a free app that helps you control your personal data, use it to make money and find great deals from brands.",
    urls: ["https://www.numerous.app/"],
  },
  {
    img: require("../assets/mootpay-logo.png"),
    title: "Moot Pay",
    description:
      "Moot Pay provides payment support services to retailers around the globe to help customers manage and validate their payments quickly and easily.",
    urls: ["https://www.mootpay.com/"],
  },
  {
    img: require("../assets/devicetrackerplus-logo.png"),
    title: "Device Tracker Plus",
    description:
      "Device tracker plus is a simple yet effective tracking app, it has helped over 1m people around the world keep their phones and their loved ones safe.",
    urls: ["https://www.devicetrackerplus.com/"],
  },
  {
    img: require("../assets/logo.png"),
    title: "Portfolio Site",
    description:
      "This webapp was created using React JS, it's hosted with github pages. It showcases expertise in software engineering and innovation.",
    urls: ["https://cameron-fuller.com"],
  },
];

export { projects };
